import { useMemo } from 'react';

/**
 * Custom hook to determine column visibility based on visibleColumns array
 * @param visibleColumns - Array of visible column names, empty array means all columns visible
 * @returns Function to check if a specific column should be shown
 */
export const useColumnVisibility = (visibleColumns: string[]) => {
  const shouldShowColumn = useMemo(
    () => (columnField: string) => {
      return (
        visibleColumns.length === 0 || visibleColumns.includes(columnField)
      );
    },
    [visibleColumns],
  );

  return { shouldShowColumn };
};
